<template>
  <div>
    <order-channel-type-form v-model="order_channel_type"></order-channel-type-form>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      order_channel_type: {
        local_attrs: [],
        global_attrs: [],
        support_url: '',
        name: '',
        module_link: '',
        uses_scheduled_import: false,
        supports_id_import: false,
        supports_statuses_import: false,
        supports_time_interval_import: false
      }
    };
  }
};
</script>
